export const SCRIPT_VIS_JS_1 =
  'https://visjs.github.io/vis-network/standalone/umd/vis-network.min.js';

export const SCRIPT_CHART_JS_1 = 'https://cdn.jsdelivr.net/npm/chart.js';
export const SCRIPT_CHART_JS_2 =
  'https://cdn.jsdelivr.net/npm/chartjs-plugin-annotation/dist/chartjs-plugin-annotation.min.js';

export const SCRIPT_MATHJAX_1 =
  'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML';

export function addScript(params: {
  id: string;
  link: string;
  onload?: Function;
}) {
  const { id, link, onload } = params;

  //   const existingScript = document.getElementById(id);

  const script = document.createElement('script');
  script.onload = () => {
    onload && onload();
  };
  script.setAttribute('id', id);
  script.setAttribute('src', link);
  document.head.appendChild(script);
}

export function isHasChartJs(html: string) {
  return (
    html.includes('Chart.js') ||
    html.includes('chart.js') ||
    html.includes('Chart') ||
    html.includes('chart') ||
    html.includes('ChartJs') ||
    html.includes('chartjs')
  );
}

export function isHasMath(html: string) {
  return html.includes('$$');
}

export function isHasVisJs(html: string) {
  return (
    html.includes('Vis.js') ||
    html.includes('vis.js') ||
    html.includes('Vis') ||
    html.includes('vis') ||
    html.includes('VisJs') ||
    html.includes('visjs')
  );
}

export function renderMathJax(questionHtml: string) {
  const windowObject: any = window;
  if (windowObject && windowObject.MathJax) {
    windowObject.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ['$', '$'],
          ['(', ')'],
        ],
        displayMath: [
          ['$$', '$$'],
          ['[', ']'],
        ],
        processEscapes: true,
        processEnvironments: true,
      },
      // Center justify equations in code and markdown cells. Elsewhere
      // we use CSS to left justify single line equations in code cells.
      displayAlign: 'center',
      'HTML-CSS': {
        styles: { '.MathJax_Display': { margin: 0 } },
        linebreaks: { automatic: true },
      },
    });
    windowObject.MathJax.Hub.Queue([
      'Typeset',
      windowObject.MathJax.Hub,
      questionHtml,
    ]);
  }
}
